import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-asbsbtmaths',
    templateUrl: './asbsbtmaths.component.html',
    styleUrls: ['./asbsbtmaths.component.scss']
})
export class AsbsbtmathsComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
